import { render, staticRenderFns } from "./IronDate3.vue?vue&type=template&id=11745e90&"
import script from "./IronDate3.vue?vue&type=script&lang=js&"
export * from "./IronDate3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports